import React, { useState } from "react";
import Footer from "../components/Footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    remarks: "",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.name) errors.name = "Full Name is required";
    if (!formData.email) errors.email = "Email is required";
    if (!formData.remarks) errors.remarks = "Remarks are required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbywRqHFyel--Oboxt9txTrSR_aQw_SzfGt3nB2DbYCl5WGjX5igpOICLHUPRU1hS-uT/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(formData).toString(),
        }
      );
      if (response) {
        setFormSubmitted(true);
        resetForm();
      }
    } catch (error) {
      console.error("Error!", error.message);
      toast.error("Seems, there is an issue with the Server.");
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      remarks: "",
    });
    setFormErrors({});
  };

  return (
    <section>
      <div className="text-[15px] font-normal">
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>

      <div className="login-banner relative justify-center flex">
        <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
          Contact Us
        </h1>
      </div>

      <div className="bg-white py-[12rem] page-padding grid grid-cols-2 container gap-10 items-center md1000:grid-cols-1">
        <div className="md1000:w-[60%] md1000:flex md1000:flex-col md1000:mx-auto min800:w-[90%] min620:w-full">
          <h2 className="text-black text-[36px] font-bold leading-[1.2]">
            We are here to help you! To Shape Your Body.
          </h2>
          <p className="text-[16px] w-[95%] text-[#646464] font-medium my-[40px]">
          At HIFI Fitness, we’re here to help you reach your fitness goals. Our trainers will work with you to create a workout plan that fits your body and lifestyle, so you can see real results.
          </p>
          <div className="grid grid-cols-2 grid-rows-2 gap-y-20 min620:grid-cols-1 min620:mx-auto">
            <div className="flex flex-col relative">
              
              <h3 className="text-[2rem] font-bold mb-10">Branch 1 & 2</h3>
              <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
              <p className="text-[15px] font-medium text-[#646464]">
              Building, 2nd Floor, Hifi Fitness 2, Kotak Bank, 108/221, Thambu Chetty St, Mannadi, Mannadi, Chennai - 600001
                <br /> 
              </p>
              <br />
              <br />
              <p className="text-[15px] font-medium text-[#646464]">
              building,2nd floor, Swimming pool, 46/111, Elaya St, New Washermenpet, Tondiarpet, Chennai, Tamil Nadu 600081
                <br /> 
              </p>

            </div>

            <div className="flex flex-col relative">
              <h3 className="text-[2rem] font-bold mb-10">Opening Hours</h3>
              <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
              <div className="text-[15px] font-medium text-[#646464]">
                <div className="grid grid-cols-[1fr,auto] gap-x-2">
                  <b>Mon to Sat :</b>
                  <span>5:30am - 10:00 pm</span>
                </div>
                <div className="grid grid-cols-[1fr,auto] gap-x-2">
                  <b>Sunday :</b>
                  <span>
                  7:00 am - 11:00 am
                    <br />
                    
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col relative">
              <h3 className="text-[2rem] font-bold mb-10">Information</h3>
              <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
              <div className="text-[15px] font-medium text-[#646464]">
                <p>+91 80561 71722
                </p>
                <p>hififitness@gmail.com</p>
              </div>
            </div>

            <div className="flex flex-col relative">
              <h3 className="text-[2rem] font-bold mb-10">Follow Us On</h3>
              <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
              <div className="text-[18px] font-medium text-black flex gap-5">
                <a href="https://www.facebook.com/p/HI-FI-Fitness-100064087483090" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-facebook-f p-[12px] bg-[#f4f4f4] rounded-full cursor-pointer hover:bg-[#1877F2] ease-in duration-200 hover:text-white"></i>
                </a>
               
                <a href="https://www.instagram.com/hifi_fitness_parrys/?hl=en" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-instagram p-[12px] bg-[#f4f4f4] rounded-full cursor-pointer hover:bg-gradient-to-r from-[#f09433] via-[#e6683c] to-[#bc1888] ease-in duration-200 hover:text-white"></i>
                </a>
                <a href="https://wa.me/+918056171722?text=Hi, I would like to join HIFI fitness" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-whatsapp bg-[#efefef] p-[12px] rounded-full cursor-pointer hover:bg-[#25D366] ease-in duration-200 hover:text-white"></i>
                </a>
               
              </div>
            </div>
          </div>
        </div>

        <form
          action="POST"
          name="contact-form"
          onSubmit={handleSubmit}
          className="flex flex-col pt-[30px] pr-[50px] pb-[50px] pl-[45px] bg-[#f8f8f8] rounded-2xl relative md1000:w-[65%] md1000:flex md1000:flex-col md1000:mx-auto md1000:mt-14 min800:w-[90%] min620:w-full"
        >
          <h3 className="text-[28px] font-bold mb-14">
            Leave Us Your Information
          </h3>
          <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[77px]"></span>
          <input
            onChange={handleChange}
            required
            value={formData.name}
            name="name"
            className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid rounded-2xl border-[#e4e4e4] outline-none mb-8"
            placeholder="Your Full Name *"
            type="text"
          ></input>
          {formErrors.name && (
            <small className="form-text text-danger">
              {formErrors.name}
            </small>
          )}

<input
            onChange={handleChange}
            required
            value={formData.email}
            name="email"
            className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid rounded-2xl border-[#e4e4e4] outline-none mb-8"
            placeholder="Email Address *"
            type="email"
          ></input>
          {formErrors.email && (
            <small className="form-text text-danger">
              {formErrors.email}
            </small>
          )}

          <textarea
            onChange={handleChange}
            required
            value={formData.remarks}
            name="remarks"
            placeholder="Comment"
            className="w-full py-[12px] px-[20px] h-[140px] text-[14px] border border-solid rounded-2xl border-[#e4e4e4] outline-none mb-8"
          ></textarea>
          {formErrors.remarks && (
            <small className="form-text text-danger">
              {formErrors.remarks}
            </small>
          )}

          <button
            type="submit"
            className="text-white bg-[#ff0336] w-fit py-[15px] px-[30px] font-bold text-[14px] uppercase self-center mt-6 rounded-2xl"
          >
            Submit Now
          </button>
          {formSubmitted && (
            <h1 className="text-align-center">
              <br />
              <b>Thanks for contacting us!</b>
            </h1>
          )}
        </form>
      </div>
      <Footer />
    </section>
  );
};

export default Contact;